import { Validator } from 'vee-validate'

// Register custom rule
Validator.extend('exclude_special_char', {
  getMessage: (field) => 'You can use letters, numbers, spaces, and any characters, except for the dollar sign ($).',
  validate: (value) => /^[^$]*$/.test(value) // Match any character except $
})
